import { addCache } from 'api/caching'
import { getCerebroHeaders } from 'api/Cerebro/headers'
import { orgScopedApiClient } from 'api/orgScopedClient'
import {
    AsyncUpdate,
    AutomationCapability,
    AutomationProfile,
    AutomationTask,
} from 'types'

import {
    CerebroApiOptionsHeaders,
    CerebroBulkUpdateResponse,
    CerebroPaginatedResponse,
    CerebroResourceResponse,
} from '../types'

export const getCampaignAutomationCapabilities = (
    campaignId: string
): Promise<CerebroPaginatedResponse<AutomationCapability>> =>
    orgScopedApiClient.get(
        `/api/campaign/${campaignId}/automation_capabilities/`
    )

export const getAutomationCapabilities = (
    params: Record<string, unknown> = {},
    options: { headers: CerebroApiOptionsHeaders } = { headers: {} }
): Promise<CerebroPaginatedResponse<AutomationCapability>> =>
    orgScopedApiClient.get(`/api/automation_capabilities/`, {
        params,
        headers: getCerebroHeaders(options.headers),
    })
addCache(getAutomationCapabilities)

export const getAutomationTasks = (
    params: Record<string, unknown> = {},
    options: { headers: CerebroApiOptionsHeaders } = { headers: {} }
): Promise<CerebroPaginatedResponse<AutomationTask>> =>
    orgScopedApiClient.get(`/api/automation_tasks/`, {
        params,
        headers: getCerebroHeaders(options.headers),
    })

export const getAutomationProfile = (
    profileId: string,
    params = {}
): Promise<CerebroResourceResponse<AutomationProfile>> =>
    orgScopedApiClient.get(`/api/automation_profile/${profileId}/`, {
        params,
    })

export const getAutomationProfiles = (
    params: Record<string, unknown> = {},
    options: { headers: CerebroApiOptionsHeaders } = { headers: {} }
): Promise<CerebroPaginatedResponse<AutomationProfile>> =>
    orgScopedApiClient.get(`/api/automation_profiles/`, {
        params,
        headers: getCerebroHeaders(options.headers),
    })

interface CreateAutomationProfile {
    name: string
    capability_id: string
    country_code: string | null
    params: Record<string, unknown>
}

export const createAutomationProfile = (
    data: CreateAutomationProfile
): Promise<CerebroResourceResponse<AutomationProfile>> =>
    orgScopedApiClient.post(`/api/automation_profiles/`, data)

export const updateAutomationProfile = (
    profileId: string,
    data: Partial<AutomationProfile>
): Promise<CerebroResourceResponse<AutomationProfile>> =>
    orgScopedApiClient.patch(`/api/automation_profile/${profileId}/`, data)

export const deleteAutomationProfile = (
    profileId: string
): Promise<CerebroResourceResponse<void>> =>
    orgScopedApiClient.delete(`/api/automation_profile/${profileId}/`)

export const createAutomationTask = (
    data: any
): Promise<CerebroResourceResponse<AutomationTask>> =>
    orgScopedApiClient.post(`/api/automation_tasks/`, data)

export const updateAutomationTask = (
    taskId: string,
    data: any
): Promise<CerebroResourceResponse<AutomationTask>> =>
    orgScopedApiClient.patch(`/api/automation_task/${taskId}/`, data)

export const updateAutomationTasks = (
    data: any,
    params: Record<string, unknown> = {}
): Promise<CerebroBulkUpdateResponse<AutomationTask>> =>
    orgScopedApiClient.patch(`/api/automation_tasks/`, data, { params })

export const asyncUpdateAutomationTask = (
    data: any,
    params: Record<string, unknown> = {},
    options: { headers: CerebroApiOptionsHeaders } = { headers: {} }
): Promise<CerebroResourceResponse<AsyncUpdate>> =>
    orgScopedApiClient.patch('/api/automation_tasks/mutate/', data, {
        params,
        headers: getCerebroHeaders(options.headers),
    })
